import type { CSSProperties } from 'react'
import { shellPathEntriesEnabled } from './shellPathEntries'

const wrap: CSSProperties = {
  padding: 24,
  fontFamily: 'system-ui, sans-serif',
  maxWidth: 560,
}

export function UnmatchedDeployPath() {
  const pathEntries = shellPathEntriesEnabled()
  return (
    <div style={wrap}>
      <h1 style={{ fontSize: 20, marginBottom: 12 }}>URL does not match this build</h1>
      <p style={{ marginBottom: 8 }}>
        {pathEntries ? (
          <>
            Open <code>/{'<contact-token>'}</code>, <code>/legacy/{'<contact-token>'}</code>, or{' '}
            <code>/new/{'<contact-token>'}</code>.
          </>
        ) : (
          <>
            Open <code>/{'<contact-token>'}</code>. The token must be the only path segment after the host
            (not <code>/legacy/...</code> or <code>/new/...</code>).
          </>
        )}
      </p>
      <p style={{ fontSize: 14, opacity: 0.85 }}>
        Local preview: <code>make -C expmgr package-site-preview</code> then{' '}
        <code>npm run preview-deploy</code>.
      </p>
    </div>
  )
}
